//** Paths */
import { Application } from 'src/config/const/enums';
import {
  gettingStartedFieldNames,
  saveAndEmailFieldNames,
} from 'src/config/pageInfo/pageFieldName';
import { pageName } from 'src/config/pageInfo/pageNames.js';
import { PATH_ONLINE_SUB, PATH_ONLINE_NAVIGATION } from 'src/routes/paths';
//* Schemas
// import { schemaPaymentDetails } from 'src/schema/paymentPaymentDetailsSchema.js';
// import { schemaPolicyOutcome } from 'src/schema/policyOutcomeSchema.js';
// import { schemaGettingStarted, schemaSaveAndEmail } from 'src/schema/preQualValidationSchema';

//** Page order */

import { pageOrder } from './pageOrder';
//** What 'stage' of the application is a particular page associated with. */
const stages = {
  PREQUAL: 'PreQualification',
  UNDERWRITING: 'UnderWriting',
  NEWBUSINESS: 'NewBusiness',
  PAYMENT: 'Payment',
};
import { sharedPages } from './sharedPages';

//* ----------------------------------------------------------------

//** The page(s) information - Controls the render and the flow */
export const onlinePages = () => {
  let pageDetails = sharedPages(Application.ONLINE, 'personOne');

  return [
    {
      index: pageOrder.ACCEPT,
      title: 'Accept and Proceed',
      identifier: pageName.ACCEPT,
      stage: stages.PREQUAL,
      routePath: PATH_ONLINE_SUB.accept,
      nextRoutePath: PATH_ONLINE_NAVIGATION.gettingStarted,
      previousRoutePath: PATH_ONLINE_NAVIGATION.accept,
      fieldNames: null,
      showProgressBar: false,
      activeStep: null,
      schema: null,
      dualSchema: null,
      valid: false, // Set to true when the next page is clicked
      allowNavigation: true,
    },
    {
      index: pageOrder.GETTING_STARTED,
      title: 'Getting Started',
      identifier: pageName.GETTING_STARTED,
      stage: stages.PREQUAL,
      routePath: PATH_ONLINE_SUB.gettingStarted,
      nextRoutePath: PATH_ONLINE_NAVIGATION.cover,
      previousRoutePath: PATH_ONLINE_SUB.gettingStarted,
      fieldNames: gettingStartedFieldNames('personOne'),
      showProgressBar: true,
      activeStep: 0,
      schema: null,
      // schema: schemaGettingStarted(),
      dualSchema: null,
      valid: false,
      allowNavigation: true,
    },
    {
      index: pageOrder.SAVE_AND_EMAIL,
      title: 'Save and Email',
      identifier: pageName.SAVE_AND_EMAIL,
      stage: stages.PREQUAL,
      routePath: PATH_ONLINE_SUB.saveAndEmail,
      nextRoutePath: PATH_ONLINE_NAVIGATION.aboutYouInformation,
      previousRoutePath: PATH_ONLINE_SUB.quote,
      fieldNames: saveAndEmailFieldNames('personOne'),
      showProgressBar: true,
      activeStep: 3,
      schema: null,
      // schema: schemaSaveAndEmail(),
      dualSchema: null,
      valid: false,
      allowNavigation: true,
    },
    {
      index: pageOrder.PP_ONLINE_PAYMENT,
      title: 'Payment Details',
      identifier: pageName.PP_ONLINE_PAYMENT,
      stage: stages.PAYMENT,
      routePath: PATH_ONLINE_SUB.ppOnlinePayment,
      nextRoutePath: PATH_ONLINE_NAVIGATION.ppConfirmation,
      previousRoutePath: PATH_ONLINE_NAVIGATION.ppContact,
      fieldNames: null,
      showProgressBar: true,
      activeStep: 6,
      schema: null,
      // schema: schemaPaymentDetails(),
      dualSchema: null,
      valid: false, // Set to true when the next page is clicked
      allowNavigation: true,
    },
    {
      index: pageOrder.PP_ONLINE_POLICY_OUTCOME,
      title: 'Policy Outcome',
      identifier: pageName.PP_ONLINE_POLICY_OUTCOME,
      stage: stages.NEWBUSINESS,
      routePath: PATH_ONLINE_SUB.ppOnlinePolicyOutcome,
      nextRoutePath: null,
      previousRoutePath: PATH_ONLINE_NAVIGATION.ppConfirmation,
      fieldNames: null,
      showProgressBar: true,
      activeStep: 5,
      schema: null,
      // schema: schemaPolicyOutcome('personOne', Application.ONLINE),
      dualSchema: null,
      valid: false, // Set to true when the next page is clicked
      allowNavigation: true,
    },
    ...pageDetails,
  ];
};
